import { gql } from '@apollo/client';

/**
 * Fetches user's pilots for over-allocation computation.
 * Used with useQueryAsUser - backend filters by impersonated user.
 */
export const userPilotsForOverAllocationQuery = gql`
  query autoPilotSettingsGet {
    autoPilotSettingsGet(input: { setupStatuses: [INITIATED, ACTIVE, PAUSED] }) {
      autoPilotSettings {
        autoPilotSettingsKey
        allocationAmount
        slavePortfolioKey
        slavePortfolio {
          portfolioKey
          portfolioName
          brokerName
        }
        masterPortfolio {
          autoPilotMasterPortfolio {
            title
          }
        }
      }
    }
  }
`;

export const balancingDecisionsGetQuery = gql`
  query balancingDecisionsGet($autoPilotSettingsKey: Int!) {
    balancingDecisionsGet(input: { autoPilotSettingsKey: $autoPilotSettingsKey }) {
      balancingParameters
      overAllocatedAmount
    }
  }
`;

export const autoPilotSettingsUpdateAllocation = gql`
  mutation autoPilotSettingsUpdateAllocation($input: AutoPilotSettingsUpdateAllocationInput!) {
    autoPilotSettingsUpdateAllocation(input: $input) {
      autoPilotSettings {
        autoPilotSettingsKey
        allocationAmount
        amountPending
      }
      marketOpen
    }
  }
`;

export const jediResolveOverAllocation = gql`
  mutation jediResolveOverAllocation($autoPilotSettingsKey: Int!) {
    jediResolveOverAllocation(input: { autoPilotSettingsKey: $autoPilotSettingsKey }) {
      success
    }
  }
`;

export interface OverAllocationSleeve {
  autoPilotSettingsKey: number;
  pilotName: string;
  allocationAmount: number;
  autopilotCash: number;
  suggestedAdjustment: number;
}

export interface OverAllocationPortfolio {
  portfolioKey: number;
  portfolioName: string;
  brokerName: string;
  buyingPower: number;
  totalAutopilotCash: number;
  overAllocation: number;
  sleeves: OverAllocationSleeve[];
}
